export enum ConfirmationMessageEvent {
  ACCEPT = 0,
  REJECT = 1,
  CANCEL = 2
}
